import type {
  CardAvailabilityConfig,
  CardAvailabilityResolution,
} from '@/shared/smartCard/types/smartCard.type';

/**
 * Resuelve la disponibilidad de tarjeta para un país a partir del config de
 * `feature_card_availability`. Prioriza la clave explícita del país sobre la
 * clave `default`; si ninguna existe, la tarjeta queda deshabilitada.
 *
 * @param countryCode - código de país tal como llega de la cuenta, en cualquier casing
 * @param config - config de Remote Config para `feature_card_availability`
 * @returns el `enabled` resuelto junto con el origen de la resolución
 */
export function resolveCardAvailability(
  countryCode: string,
  config: CardAvailabilityConfig | null | undefined
): CardAvailabilityResolution {
  if (!countryCode || !config || typeof config !== 'object') {
    return { isEnabled: false, source: 'none' };
  }

  const countryKey = countryCode.toLowerCase();
  const explicitConfig = config[countryKey];

  if (explicitConfig) {
    return { isEnabled: explicitConfig.enabled, source: 'explicit' };
  }

  const defaultConfig = config.default;

  if (defaultConfig) {
    return { isEnabled: defaultConfig.enabled, source: 'default' };
  }

  return { isEnabled: false, source: 'none' };
}
